// @ts-nocheck
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export const orderSubtitleSpacingStyles = () => css`
    ${breakpointValues(pxToRemArray([12, null, 14, null, 16]), "margin-bottom")}

    &:last-child {
        margin-bottom: 0;
    }
`;
